module.exports = __webpack_public_path__ + "static/shopify_installed-21a01cfa7b71cc8f01b518e60b0fb5bd.png";